import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class DelayedUserInputService {

    DUE_TIME = 1000;
    currentUserInputValue: string = null;
    currentUserInput = new Subject<string>();
    userInputFinished = new Subject<string>();

    private userInputDebouncer = new Subject();

    constructor() {
        this.userInputDebouncer.pipe(debounceTime(this.DUE_TIME)).subscribe(() => {
            this.userInputFinished.next(this.currentUserInputValue);
            this.currentUserInputValue = null;
            this.currentUserInput.next(null);
        });
    }

    fireNextUserInput(userInputName: string) {
        this.currentUserInputValue = userInputName;
        this.currentUserInput.next(userInputName);
        this.userInputDebouncer.next();
    }

}
